import { render, staticRenderFns } from "./RewardDepositBarChart.vue?vue&type=template&id=5429bea4&scoped=true"
import script from "./RewardDepositBarChart.vue?vue&type=script&lang=js"
export * from "./RewardDepositBarChart.vue?vue&type=script&lang=js"
import style0 from "./RewardDepositBarChart.vue?vue&type=style&index=0&id=5429bea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429bea4",
  null
  
)

export default component.exports